import { PrivateGitSelectorFallback } from '@/components/form/private-git-selector/fallback'
import { H3, H4 } from '@/components/sv/typographies'
import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import { BuildSettingsFallback } from '@/routes/static-sites/create-static-site/form/sections/build-settings/fallback'
import { NameFallback } from '@/routes/static-sites/create-static-site/form/sections/name/fallback'
import { OverviewFallback } from '@/routes/static-sites/create-static-site/form/sections/overview/fallback'
import { PaymentMethodFallback } from '@/routes/static-sites/create-static-site/form/sections/payment-method/fallback'

export const CreateStaticSiteFallback = () => {
  return (
    <div className="grid gap-4 grid-cols-1 lg:grid-cols-[2fr_1fr]">
      <Card>
        <CardContent className="p-0">
          <H3 className="mb-6 px-6">Static site details</H3>
          <div className="space-y-6">
            <div className="px-6 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <Skeleton className="h-22 w-full" />
                <Skeleton className="h-22 w-full" />
              </div>
              <PrivateGitSelectorFallback showBranchSelector />
              <NameFallback />
            </div>
            <Separator />
            <div className="px-6 space-y-6">
              <H4>Deployment settings</H4>
              <Skeleton className="h-18 w-full" />
              <Skeleton className="h-23 w-full" />
            </div>
            <Separator />
            <div className="px-6 space-y-6">
              <BuildSettingsFallback showFramework={false} />
            </div>
            <div className="px-6 space-y-6">
              <H4>Environment variables</H4>
              <div className="grid grid-cols-2 items-start gap-4">
                <div className="flex flex-col gap-2">
                  <Skeleton className="h-3.5 w-25" />
                  <Skeleton className="w-full h-9" />
                </div>
                <div className="flex flex-col gap-2">
                  <Skeleton className="h-3.5 w-25" />
                  <Skeleton className="w-full h-9" />
                </div>
              </div>
              <div className="space-y-2">
                <Skeleton className="h-9 w-33" />
                <Skeleton className="h-9 w-37" />
              </div>
              <Skeleton className="h-9 w-40" />
            </div>
          </div>
        </CardContent>
      </Card>
      <div className="flex flex-col gap-4">
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Overview</H3>
              <div className="flex flex-col gap-6">
                <OverviewFallback />
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Payment method</H3>
              <div className="flex flex-col gap-6">
                <PaymentMethodFallback />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
